import { PropsWithChildren, useCallback, ReactNode } from "react";
import { ResizeSensor } from "@blueprintjs/core";
import { PageContent, PageHeaderWrap, PageWrapStyled } from "./Styles";

import { SizeType } from "../ResizeSensor";

export type { SizeType } from "@/shared/components/ResizeSensor";
export * from "./Header";

export interface IPageWrapProps {
  header?: ReactNode;
  onResize?: (value: SizeType) => void;
}
const PageWrap = ({
  header,
  onResize,
  children,
}: PropsWithChildren<IPageWrapProps>) => {
  const handleResize = useCallback(
    ([{ contentRect }]: ResizeObserverEntry[]) => {
      if (typeof onResize === "function") {
        onResize({
          width: Math.floor(contentRect.width),
          height: Math.floor(contentRect.height),
        });
      }
    },
    [onResize]
  );

  return (
    <PageWrapStyled className="flex flex-col">
      {header && <PageHeaderWrap>{header}</PageHeaderWrap>}
      <ResizeSensor onResize={handleResize}>
        <PageContent className="flex-1 min-h-0">{children}</PageContent>
      </ResizeSensor>
    </PageWrapStyled>
  );
};

export default PageWrap;
